import { useState, React } from 'react';
import { Modal, Button, Form, Input } from 'antd';
import { EditOutlined } from '@ant-design/icons';

const EditModal = () => {
  const [visible, setVisible] = useState(false);

  const onFinish = (values) => {
    console.log('Received values of form: ', values);
    setVisible(false);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <>
      <Button
        icon={<EditOutlined />}
        type="primary"
        style={{ backgroundColor: '#fa8c16' }}
        onClick={() => setVisible(true)}>
        修改
      </Button>
      <Modal
        title="修改信息"
        open={visible}
        onCancel={() => setVisible(false)}
        footer={[
          <Button key="back" onClick={() => setVisible(false)}>
            取消
          </Button>,
          <Button form="editForm" key="submit" htmlType="submit" type="primary">
            確定
          </Button>,
        ]}>
        <Form id="editForm" onFinish={onFinish} onFinishFailed={onFinishFailed}>
          <Form.Item
            label="使用者"
            name="user"
            rules={[{ required: true, message: '請輸入使用者!' }]}>
            <Input />
          </Form.Item>
          <Form.Item
            label="修改項目1"
            name="item1"
            rules={[{ required: true, message: '請輸入修改項目1!' }]}>
            <Input />
          </Form.Item>
          <Form.Item
            label="修改項目2"
            name="item2"
            rules={[{ required: true, message: '請輸入修改項目2!' }]}>
            <Input />
          </Form.Item>
          <Form.Item
            label="修改項目3"
            name="item3"
            rules={[{ required: true, message: '請輸入修改項目3!' }]}>
            <Input />
          </Form.Item>
          <Form.Item
            label="修改項目4"
            name="item4"
            rules={[{ required: true, message: '請輸入修改項目4!' }]}>
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default EditModal;
